angular.module('webremote.service.objectManager').filter('referenceResolver', function (objectManagerService) {
  return function (uuids, ObjectType) {
    if (uuids === undefined) {
      return []
    }
    return uuids.map(uuid => objectManagerService.objectSync(uuid, ObjectType))
  }
})
